import { ReferenceTableDeletedEvent, } from '../event/reference-table-deleted.event';
const referenceTableDeletedProjections = {
    [ReferenceTableDeletedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        return {
            ...state,
            deleted: payload.deleted,
        };
    },
};
export default referenceTableDeletedProjections;
//# sourceMappingURL=reference-table-deleted.projection.js.map